import { map, filter, take, withLatestFrom, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import Actions from '../actions'
import debugUtils from '../utils/debugUtils'
import { getPayload } from 'utils/rxUtils'
import { STEPS } from 'consts/flowConsts'
import { deserializeEnrolles } from 'utils/serializers/memberDeserializers'
import { ROUTE_STEP } from 'consts/flowConsts'
import { getSkipStepAction } from 'utils/debugUtils/applicationDebugUtil'
import { of } from 'rxjs'

const { isActiveFlag } = debugUtils

export const fillMockApplication = action$ =>
  action$.pipe(
    ofType(Actions.APP_LAUNCHED),
    take(1),
    filter(() => isActiveFlag(debugUtils.AUTO_FILL_APPLICATION_KEY)),
    map(() =>
      Actions.createAction(
        Actions.AUTO_FILL_APPLICATION,
        debugUtils.defaultDebugApplication
      )
    )
  )

export const fillMockZip = action$ =>
  action$.pipe(
    ofType(Actions.APP_LAUNCHED),
    take(1),
    filter(() => isActiveFlag(debugUtils.AUTO_FILL_ZIP_KEY)),
    map(() =>
      Actions.createAction(Actions.AUTO_FILL_ZIP, debugUtils.defaultZipayload)
    )
  )

export const fillMockInfo = action$ =>
  action$.pipe(
    getPayload(Actions.MEMBERS_UPDATED),
    take(1),
    filter(() => isActiveFlag(debugUtils.AUTO_FILL_ENROLLEES_KEY)),
    map(() =>
      Actions.createAction(
        Actions.AUTO_FILL_ENROLLEES,
        deserializeEnrolles(debugUtils.defaultDebugEnrollees)
      )
    )
  )

export const fillMockQuliftLifeEvent = action$ =>
  action$.pipe(
    getPayload(Actions.STEP_COMPLETED),
    filter(({ step }) => step === STEPS.INFO),
    take(1),
    filter(() => isActiveFlag(debugUtils.AUTO_FILL_QULIFY_KEY)),
    map(() =>
      Actions.createAction(
        Actions.AUTO_FILL_QUALLIFY_LIFE_EVENT,
        debugUtils.defaultQulifyLifeEventPayload
      )
    )
  )

export const skipStep = (action$, state$) =>
  action$.pipe(
    ofType(Actions.DEBUG_SKIP_STEP),
    withLatestFrom(state$),
    switchMap(([_, { app }]) => {
      const step = ROUTE_STEP[app.locationRoute?.pathname]
      const { action, payload } = getSkipStepAction(step)
      return of(
        Actions.createAction(action, payload),
        Actions.createAction(Actions.STEP_COMPLETED, {
          step
        })
      )
    })
  )
